// import React, { useEffect, useRef, useState } from "react";
// import {
//   AdvSeparator,
//   Button,
//   Chip,
//   CkTextEditor,
//   CopyToClipboard,
//   DetailCard,
//   Divider,
//   InfoTextAdv,
//   LogoLoader,
//   Modal,
//   showToast,
// } from "../../../../components";
// import SaveEmailTemplate from "./EmailTemplatemplate/SaveEmailTemplate";
// import ViewEmailTemplate from "./EmailTemplatemplate/ViewEmailTemplate";
// import { useDispatch, useSelector } from "react-redux";
// import { getTemplatesStart, getTemplatesSuccess } from "../../../../redux/slices/compaigns/compaignsSlice";
// import { deleteTemplate, fetchTemplateById } from "../../../../redux/slices/compaigns/compaignsApi";

// const EmailTemplates = () => {
//   const [saveEmailModal, setSaveEmailModal] = useState(false);
//   const [viewEmailModal, setViewEmailModal] = useState(false);
//   const dispatch = useDispatch();
//   const templates = useSelector((state) => state.compaigns.emailTemplates.templates);
//   const [emailBody, setEmailBody] = useState("");
//   const [templateId, setTemplateId] = useState(null);
//   const [editTemplate, setEditTemplate] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const editorRef = useRef(null);
//   const [savedRange, setSavedRange] = useState(null);
//   const cardsCount = 8;
//   const headeRightIcons = ["file_copy"];

//   const handleCloseSaveEmail = () => {
//     setSaveEmailModal(false);
//     setEditTemplate(null);
//     setEmailBody("");
//   };

//   const handleCloseViewEmail = () => {
//     setViewEmailModal(false);
//     setTemplateId(null);
//   };
//   const handleDeteteTemplate = (uiid) => async () => {
//     try {
//       const res = await deleteTemplate({ coll: "Template", uiid });
//       if(res?.data) {
//         showToast("Template deleted successfully", "success",2000);
//         dispatch(getTemplatesStart({ coll: "Template", lim: 10, pg: 1, ret: "uiid addedBy usedCount addedOn modified", extret : "uiid firstName lastName email" }));
//         setEmailBody("")
//       }
//     } catch (error) {
//       console.error("Failed to delete template:", error);
//     }
//   }

//   const handleEditTemplate = async (uiid) => {
//   try {
//     setLoading(true);
//     let filter = {
//       uiid: {
//         type: "IN",
//         value: [uiid],
//       },
//     };
//     const response = await fetchTemplateById({
//       coll: "Template",
//       fil: filter,
//       ret: "uiid title subject body assignedTo",
//     });

//     const template = response?.data;
//     if (template) {
//       setEmailBody(template.body || "");
//       setEditTemplate(template);
//     }
//   } catch (error) {
//     console.error("Error fetching template for edit:", error);
//     showToast("Failed to load template", "error");
//   } finally{
//     setLoading(false);
//   }
// };

// const handleInsertChip = (chipText) => {
//   const editorEl = editorRef.current?.querySelector('[contenteditable="true"]');
//   if (!editorEl) return;

//   editorEl.focus();

//   let sel = window.getSelection();

//   if (savedRange) {
//     // restore saved caret
//     sel.removeAllRanges();
//     sel.addRange(savedRange);
//   }

//   if (!sel || sel.rangeCount === 0) {
//     // fallback: append to end
//     editorEl.innerHTML += chipText;
//     setEmailBody(editorEl.innerHTML);
//     return;
//   }

//   const range = sel.getRangeAt(0);
//   range.deleteContents();

//   const textNode = document.createTextNode(chipText);
//   range.insertNode(textNode);

//   // move caret after inserted chip
//   range.setStartAfter(textNode);
//   range.setEndAfter(textNode);
//   sel.removeAllRanges();
//   sel.addRange(range);

//   // save updated range for next insert
//   setSavedRange(range);

//   setEmailBody(editorEl.innerHTML);
// };

// //   const handleInsertChip = (label) => {
// //   if (!editorInstance) {
// //     setEmailBody((prev) => prev + label);
// //     return;
// //   }

// //   editorInstance.model.change((writer) => {
// //     const selection = editorInstance.model.document.selection;
// //     const position = selection.getFirstPosition();

// //     if (!position) return;

// //     // Insert text exactly at the current position
// //     writer.insertText(label, position);

// //     // Move cursor to after inserted text
// //     const newPosition = writer.createPositionAfter(position.nodeAfter || position.node);
// //     writer.setSelection(newPosition);
// //   });
// // };

//   useEffect(() => {
//     dispatch(
//       getTemplatesStart({
//         coll: "Template",
//         lim: 100,
//         pg: 1,
//         ret: "uiid addedBy usedCount addedOn modified",
//         extret : "uiid firstName lastName email"
//       })
//     );
//   }, []);
//   useEffect(() => {
//   const editorEl = editorRef.current?.querySelector('[contenteditable="true"]');
//   if (!editorEl) return;

//   const saveSelection = () => {
//     const sel = window.getSelection();
//     if (sel && sel.rangeCount > 0) {
//       setSavedRange(sel.getRangeAt(0));
//     }
//   };

//   editorEl.addEventListener("keyup", saveSelection);
//   editorEl.addEventListener("mouseup", saveSelection);

//   return () => {
//     editorEl.removeEventListener("keyup", saveSelection);
//     editorEl.removeEventListener("mouseup", saveSelection);
//   };
// }, []);

//   return (

//     <div className="py-2 h-full pt-5 px-2 flex gap-4 overflow-hidden">

//       <div className="flex-1 shadow-md rounded-lg overflow-auto">
//         <div className="bg-gray-50 text-primary font-semibold p-2 rounded-t-lg">
//           Email Template
//         </div>

//         <div className="p-3 flex flex-col">
//           {/* <CkTextEditor
//           value={emailBody}
//           // onChange={(data) => setEmailBody(data)}
//           onChange={(data, editor) => {
//             setEmailBody(data);
//             if (!editorInstance) setEditorInstance(editor);
//           }}
//           /> */}
//           <div ref={editorRef}>
//   <CkTextEditor
//     value={emailBody}
//     onChange={(data) => setEmailBody(data)}
//   />
// </div>

//           <div className="flex gap-1 mt-3">
//             <Chip
//               label={"{firstName}"}
//               variant="outlined"
//               className="bg-gray-50 !text-black border border-info-100 !py-1 !px-2"
//                onClick={() => handleInsertChip("{firstName}")}
//             />
//             <Chip
//               label={"{lastName}"}
//               variant="outlined"
//               className="bg-gray-50 !text-black border border-info-100 !py-1 !px-2"
//               onClick={() => handleInsertChip("{lastName}")}
//             />
//             <Chip
//               label={"{jobTitle}"}
//               variant="outlined"
//               className="bg-gray-50 !text-black border border-info-100 !py-1 !px-2"
//               onClick={() => handleInsertChip("{jobTitle}")}
//             />
//             <Chip
//               label={"{jobLocation}"}
//               variant="outlined"
//               className="bg-gray-50 !text-black border border-info-100 !py-1 !px-2"
//               onClick={() => handleInsertChip("{jobLocation}")}
//             />
//             <Chip
//               label={"{jobDescription}"}
//               variant="outlined"
//               className="bg-gray-50 !text-black border border-info-100 !py-1 !px-2"
//               onClick={() => handleInsertChip("{jobLocation}")}
//             />
//           </div>

//           <div className="self-center mt-15">
//             <Button
//               type="button"
//               title={"Save Content"}
//               onClick={() => setSaveEmailModal(true)}
//             />
//           </div>
//         </div>
//       </div>

//       <div className="w-[480px] shadow-md rounded-lg overflow-auto">
//         <div className="bg-gray-50 text-primary font-semibold p-2 rounded-t-lg flex flex-col">
//           All Template
//         </div>

//         <div className="px-4 py-3 flex-1 flex flex-col gap-3">
//           {templates && templates.length > 0 ? (
//     templates.map((template) => (
//       <div className="my-3" key={template._id}>
//         <DetailCard
//           className={"rounded-xl"}
//           size="xs-sm"
//           title={
//             <div className="flex justify-around">
//               <div className="text-primary mx-3 my-auto">
//                 <span className="material-symbols-outlined !text-4xl">
//                   business_center
//                 </span>
//               </div>
//               <div className="flex flex-col">
//                 <div className="flex items-center gap-3">
//                   <h6 className="text-xs">{template.addedBy.firstName} {template.addedBy.lastName || ""}</h6>
//                   <Divider orientation="vertical" />
//                   <p className="text-xs">{template.addedBy.firstName}</p>
//                 </div>
//                 <div className="flex items-center gap-3 text-gray-400">
//                   <span className="flex items-center text-xs">
//                     <CopyToClipboard title={template?.addedBy.email?.primary || template?.addedBy?.email || ""} />
//                     <span>{template?.addedBy.email?.primary || template?.addedBy?.email || ""}</span>
//                   </span>
//                   <Divider orientation="vertical" />
//                   <span className="text-xs">Used: {template.usedCount}</span>
//                 </div>
//               </div>
//             </div>
//           }
//           headeRight={
//             <div className="flex">
//               <Button
//                 icon={"visibility"}
//                 type="icon"
//                 size="sm"
//                 variant="text"
//                 color="black"
//                 onClick={() => {
//                   setViewEmailModal(true)
//                   setTemplateId(template.uiid);
//                 }}
//               />
//               <Button
//                 icon={"edit_square"}
//                 type="icon"
//                 size="sm"
//                 variant="text"
//                 color="black"
//                 onClick={() => handleEditTemplate(template.uiid)}
//               />
//               {headeRightIcons.map((icon) => (
//                 <Button
//                   key={icon}
//                   icon={icon}
//                   type="icon"
//                   size="sm"
//                   variant="text"
//                   color="black"
//                 />
//               ))}
//               <Button
//               icon={"delete"}
//               type="icon"
//               size="sm"
//               variant="text"
//               color="black"
//               onClick={handleDeteteTemplate(template.uiid)}
//             />
//             </div>
//           }
//         >
//           <div className="flex justify-around gap-3 p-3">
//             <InfoTextAdv
//               title={"Created On"}
//               size="sm"
//               titleProps={{ className: "!text-black" }}
//               value={
//                 <h6 className="line-clamp-1 text-black text-lg">
//                   {new Date(template.addedOn).toLocaleString("en-US", {
//                     month: "long",
//                     day: "numeric",
//                     year: "numeric",
//                   })}
//                 </h6>
//               }
//             />
//             <Divider orientation="vertical" />
//             <InfoTextAdv
//               title={"Last Used"}
//               titleProps={{ className: "!text-black" }}
//               size="sm"
//               value={
//                 <h6 className="line-clamp-1 text-black">
//                   {new Date(template.lastUsed).toLocaleString("en-US", {
//                     month: "long",
//                     day: "numeric",
//                     year: "numeric",
//                   })}
//                 </h6>
//               }
//             />
//             <Divider orientation="vertical" />
//             <InfoTextAdv
//               title={"Modified On"}
//               size="sm"
//               titleProps={{ className: "!text-black" }}
//               value={
//                 <h6 className="line-clamp-1 text-black">
//                    {new Date(template.modified).toLocaleString("en-US", {
//                     month: "long",
//                     day: "numeric",
//                     year: "numeric",
//                   })}
//                 </h6>
//               }
//             />
//           </div>
//         </DetailCard>
//       </div>
//     ))
//           ) : (
//             <p className="text-center text-gray-500">No templates available</p>
//           )}

//         </div>
//       </div>

//       <Modal
//         isOpen={saveEmailModal}
//         width="max-w-4xl"
//         onClose={handleCloseSaveEmail}
//         title="Save Email Template"
//       >
//         <SaveEmailTemplate onCancel={handleCloseSaveEmail} emailBody={emailBody} setEmailBody={setEmailBody} editTemplate={editTemplate} />
//       </Modal>

//       <Modal
//         isOpen={viewEmailModal}
//         width="max-w-4xl"
//         onClose={handleCloseViewEmail}
//         title="View Email Template"
//       >
//         <ViewEmailTemplate onCancel={handleCloseViewEmail} templateId={templateId} setEmailBody={setEmailBody} />
//       </Modal>
//       {loading && (
//       <div className="absolute inset-0 flex items-center justify-center bg-white/40 backdrop-blur-sm z-50 rounded-lg">
//         <LogoLoader />
//       </div>
//     )}
//     </div>
//   );
// };

// export default EmailTemplates;

import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Backdrop,
  Button,
  Chip,
  CkTextEditor,
  CopyToClipboard,
  DetailCard,
  Divider,
  FormFieldSet,
  InfoTextAdv,
  LogoLoader,
  Modal,
  NewTab,
  showToast,
} from "../../../../components";
import SaveEmailTemplate from "./EmailTemplatemplate/SaveEmailTemplate";
import ViewEmailTemplate from "./EmailTemplatemplate/ViewEmailTemplate";
import { useDispatch, useSelector } from "react-redux";
import {
  getTemplatesStart,
  appendTemplates,
  removeTemplate,
  clearTemplates,
} from "../../../../redux/slices/compaigns/compaignsSlice";
import {
  deleteTemplate,
  fetchTemplateById,
  fetchAllTemplates,
} from "../../../../redux/slices/compaigns/compaignsApi";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { formatWords2 } from "../../../../utils/stringUtils";

const EmailTemplates = () => {
  const [saveEmailModal, setSaveEmailModal] = useState(false);
  const [viewEmailModal, setViewEmailModal] = useState(false);
  const dispatch = useDispatch();
  const templates = useSelector(
    (state) => state?.compaigns?.emailTemplates?.templates,
  );
  const { user } = useSelector((state) => state?.auth);
  const { loading } = useSelector((state) => state?.compaigns);
  const { value } = useSelector((state) => state?.totalCount);
  const totalCount = value?.templateCount?.data || 0;
  // console.log(templates)
  const [emailBody, setEmailBody] = useState("");
  const [templateId, setTemplateId] = useState(null);
  const [editTemplate, setEditTemplate] = useState(null);
  const [loading1, setLoading1] = useState(false);
  const editorRef = useRef(null);
  const [savedRange, setSavedRange] = useState(null);
  const [activeTemplateTab, setActiveTemplateTab] = useState(0);
  const cardsCount = 8;
  const headeRightIcons = ["file_copy"];
  // Infinite scroll states
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const scrollContainerRef = useRef(null);
  const [searchValue, setSearchValue] = useState("");

  // Below suits pagination like 1-5, 6-10, 11-15, ...
  // const PAGE_LIMIT = 5;

  // const paginationStart =
  //   totalCount === 0
  //     ? 0
  //     : Math.min((currentPage - 1) * PAGE_LIMIT + 1, totalCount);

  // const paginationEnd = Math.min(
  //   currentPage * PAGE_LIMIT,
  //   totalCount
  // );

  // Below suits pagination like 1-5, 1-10, 1-15, ...
  const safeTemplates = Array.isArray(templates) ? templates : [];
  const paginationStart = safeTemplates?.length > 0 ? 1 : 0;

  const paginationEnd = Math.min(safeTemplates.length, totalCount);
  const useDebounce = (value, delay = 300) => {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
      const timer = setTimeout(() => setDebounced(value), delay);
      return () => clearTimeout(timer);
    }, [value, delay]);

    return debounced;
  };
  const debouncedSearch = useDebounce(searchValue, 300);
  // const buildTemplateFilter = () => {
  //   if (activeTemplateTab === 0) {
  //     return {
  //       addedBy: {
  //         type: "NONE",
  //         value: user?.data?.uiid,
  //       },
  //     };
  //   }
  //   return undefined;
  // };
  const buildTemplateFilter = useCallback(() => {
    let filter = {};

    if (activeTemplateTab === 0) {
      filter.addedBy = {
        type: "NONE",
        value: user?.data?.uiid,
      };
    }

    if (debouncedSearch?.trim()) {
      filter.title = {
        type: "SEARCH",
        value: debouncedSearch.trim(),
      };
    }

    return Object.keys(filter).length ? filter : undefined;
  }, [activeTemplateTab, debouncedSearch]);

  const handleCloseSaveEmail = () => {
    setSaveEmailModal(false);
    setEditTemplate(null);
    setEmailBody("");
  };

  const handleCloseViewEmail = () => {
    setViewEmailModal(false);
    setTemplateId(null);
  };

  const handleDeteteTemplate = (uiid) => async () => {
    try {
      const res = await deleteTemplate({ coll: "Template", uiid });
      if (res?.data) {
        showToast("Template deleted successfully", "success", 2000);
        // Reset pagination and reload from beginning
        setCurrentPage(1);
        setHasMore(true);
        dispatch(removeTemplate(uiid));
        dispatch(
          getTemplatesStart({
            coll: "Template",
            lim: 5,
            pg: 1,
            ret: "uiid addedBy usedCount addedOn modified title",
            extret: "uiid firstName lastName email",
            sort: { addedOn: -1 },
            fil: buildTemplateFilter(),
          }),
        );
        setEmailBody("");
      }
    } catch (error) {
      console.error("Failed to delete template:", error);
    }
  };

  const handleEditTemplate = async (uiid) => {
    try {
      setLoading1(true);
      let filter = {
        uiid: {
          type: "IN",
          value: [uiid],
        },
      };
      const response = await fetchTemplateById({
        coll: "Template",
        fil: filter,
        ret: "uiid title subject body assignedTo",
        sort: { addedOn: -1 },
        extret: "uiid firstName lastName",
      });

      const template = response?.data;
      if (template) {
        setEmailBody(template.body || "");
        setEditTemplate(template);
        // setSaveEmailModal(true);
      }
    } catch (error) {
      console.error("Error fetching template for edit:", error);
      showToast("Failed to load template", "error");
    } finally {
      setLoading1(false);
    }
  };
  const handleDuplicateTemplate = async (uiid) => {
    try {
      setLoading1(true);
      let filter = {
        uiid: {
          type: "IN",
          value: [uiid],
        },
      };
      const response = await fetchTemplateById({
        coll: "Template",
        fil: filter,
        ret: "uiid title subject body assignedTo",
        sort: { addedOn: -1 },
        extret: "uiid firstName lastName",
      });

      const template = response?.data;
      if (template) {
        setEmailBody(template.body || "");
      }
    } catch (error) {
      console.error("Error fetching template for edit:", error);
      showToast("Failed to load template", "error");
    } finally {
      setLoading1(false);
    }
  };

  const handleInsertChip = (chipText) => {
    const editorEl = editorRef.current?.querySelector(
      '[contenteditable="true"]',
    );
    if (!editorEl) return;

    editorEl.focus();

    let sel = window.getSelection();

    if (savedRange) {
      // restore saved caret
      sel.removeAllRanges();
      sel.addRange(savedRange);
    }

    if (!sel || sel.rangeCount === 0) {
      // fallback: append to end
      editorEl.innerHTML += chipText;
      setEmailBody(editorEl.innerHTML);
      return;
    }

    const range = sel.getRangeAt(0);
    range.deleteContents();

    const textNode = document.createTextNode(chipText);
    range.insertNode(textNode);

    // move caret after inserted chip
    range.setStartAfter(textNode);
    range.setEndAfter(textNode);
    sel.removeAllRanges();
    sel.addRange(range);

    // save updated range for next insert
    setSavedRange(range);

    setEmailBody(editorEl.innerHTML);
  };

  // Load more templates function
  const loadMoreTemplates = useCallback(async () => {
    if (isLoadingMore || !hasMore) return;

    setIsLoadingMore(true);
    try {
      const response = await fetchAllTemplates({
        coll: "Template",
        lim: 5,
        pg: currentPage + 1,
        ret: "uiid addedBy usedCount addedOn modified title",
        extret: "uiid firstName lastName email",
        sort: { addedOn: -1 },
        fil: buildTemplateFilter(),
      });

      if (response.data && response.data.length > 0) {
        // Use appendTemplates action to add new templates
        dispatch(
          appendTemplates({
            data: response.data,
          }),
        );
        setCurrentPage((prev) => prev + 1);

        // Check if there are more items to load
        if (response.data.length < 5) {
          setHasMore(false);
        }
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error loading more templates:", error);
      // showToast("Error loading more templates", "error"); //commented because it was spamming this error message even when scrolling at the bottom after all items are loaded
    } finally {
      setIsLoadingMore(false);
    }
  }, [currentPage, hasMore, isLoadingMore, dispatch, buildTemplateFilter]);

  // Scroll event handler
  const handleScroll = useCallback(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    const isNearBottom = scrollTop + clientHeight >= scrollHeight - 100; // 100px threshold

    if (isNearBottom && hasMore && !isLoadingMore) {
      loadMoreTemplates();
    }
  }, [hasMore, isLoadingMore, loadMoreTemplates]);

  // Initial load with 5 items only
  useEffect(() => {
    dispatch(clearTemplates());
    dispatch(
      totalCountStart({
        collection: "templates",
        coll: "Template",
        tname: "templateCount",
        app: "ats",
        filters: buildTemplateFilter(),
      }),
    );
    dispatch(
      getTemplatesStart({
        coll: "Template",
        lim: 5,
        pg: 1,
        ret: "uiid addedBy usedCount addedOn modified title",
        extret: "uiid firstName lastName email",
        sort: { addedOn: -1 },
        fil: buildTemplateFilter(),
      }),
    );
  }, [dispatch, activeTemplateTab, debouncedSearch]);

  // Add scroll listener
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  useEffect(() => {
    const editorEl = editorRef.current?.querySelector(
      '[contenteditable="true"]',
    );
    if (!editorEl) return;

    const saveSelection = () => {
      const sel = window.getSelection();
      if (sel && sel.rangeCount > 0) {
        setSavedRange(sel.getRangeAt(0));
      }
    };

    editorEl.addEventListener("keyup", saveSelection);
    editorEl.addEventListener("mouseup", saveSelection);

    return () => {
      editorEl.removeEventListener("keyup", saveSelection);
      editorEl.removeEventListener("mouseup", saveSelection);
    };
  }, []);

  useEffect(() => {
    setCurrentPage(1);
    setHasMore(true);
    setSearchValue("");
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
  }, [activeTemplateTab]);

  return (
    <div className="py-2 h-full pt-5 px-2 flex flex-col lg:flex-row gap-4 overflow-auto xl:overflow-hidden">
      {/* Email Editor Section - Takes full width on mobile, flex-1 on larger screens */}
      <div className="w-full lg:flex-1 shadow-md rounded-lg overflow-auto min-h-full">
        <div className="bg-gray-50 text-primary font-semibold p-2 rounded-t-lg">
          Email Template
        </div>

        <div className="p-3 flex flex-col">
          <div ref={editorRef}>
            <CkTextEditor
              value={emailBody}
              onChange={(data) => setEmailBody(data)}
            />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-4 lg:grid-cols-2 gap-1 mt-3">
            <Chip
              label={"${firstName}"}
              variant="outlined"
              className="bg-gray-50 !text-black border border-info-100 !py-1 !px-2"
              onClick={() => handleInsertChip("${firstName}")}
            />
            <Chip
              label={"${lastName}"}
              variant="outlined"
              className="bg-gray-50 !text-black border border-info-100 !py-1 !px-2"
              onClick={() => handleInsertChip("${lastName}")}
            />
            <Chip
              label={"${jobTitle}"}
              variant="outlined"
              className="bg-gray-50 !text-black border border-info-100 !py-1 !px-2"
              onClick={() => handleInsertChip("${jobTitle}")}
            />
            <Chip
              label={"${jobLocation}"}
              variant="outlined"
              className="bg-gray-50 !text-black border border-info-100 !py-1 !px-2"
              onClick={() => handleInsertChip("${jobLocation}")}
            />
            <Chip
              label={"${jobDescription}"}
              variant="outlined"
              className="bg-gray-50 !text-black border border-info-100 !py-1 !px-0"
              onClick={() => handleInsertChip("${jobDescription}")}
            />
          </div>

          <div className="self-center mt-8">
            <Button
              type="button"
              title={"Save Content"}
              onClick={() => {
                if (!emailBody || emailBody.trim() === "") {
                  showToast("Please fill the template", "error");
                  return;
                }
                setSaveEmailModal(true);
              }}
            />
          </div>
        </div>
      </div>

      {/* Old Template  */}

      {/* new Template */}
      <div className="w-full xl:w-[480px] lg:w-[380px] shadow rounded-lg flex flex-col overflow-auto min-h-full">
        <div className="bg-gray-50 px-3 lg:pt-2">
          <NewTab
            tabs={[
              { type: "main", title: "My templates" },
              { type: "main", title: "All Templates" },
            ]}
            color="gray"
            variant="text"
            activeVariant="text"
            onTabChange={(i) => setActiveTemplateTab(i)}
          />
        </div>

        <div className="flex items-center justify-between px-4 lg:py-2 md:pt-1 text-xs">
          <span className="text-gray-500">
            {paginationStart} – {paginationEnd} of {totalCount}
          </span>

          <div className="relative">
            {/* <input
              type="text"
              placeholder="Search Template"
              disabled
              className="border rounded-full px-3 py-1 pr-8 text-xs bg-gray-100 cursor-not-allowed"
            /> */}
            <FormFieldSet
              // title="Template Name"
              value={searchValue}
              onChange={(val) => setSearchValue(val)}
              placeholder="Template Name"
              type="search"
              noTitle
              rounded="rounded-full"
            />
            <span className="material-symbols-outlined absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 text-sm">
              search
            </span>
          </div>
        </div>
        <div
          ref={scrollContainerRef}
          className="md:grid md:grid-cols-2 flex flex-col lg:flex gap-4 overflow-auto md:px-3 lg:p-3"
        >
          {templates && templates.length > 0 ? (
            <>
              {templates.map((template) => (
                <div className="my-3" key={template?._id}>
                  <DetailCard
                    className={"rounded-xl"}
                    size="xs-sm"
                    title={
                      <div className="flex items-center gap-1">
                        <div className="text-primary flex-shrink-0 mx-1 lg:mx-3 my-auto">
                          <span className="material-symbols-outlined text-2xl lg:!text-4xl">
                            business_center
                          </span>
                        </div>
                        <div className="flex flex-col min-w-0">
                          <div className="flex  items-center gap-1 min-w-0">
                            <h6 className="text-[10px] lg:text-xs truncate max-w-[70px] lg:max-w-none">
                              {formatWords2(template?.title) || ""}
                            </h6>
                            <Divider orientation="vertical" />
                            <p className="text-[10px] lg:text-xs truncate">
                              {formatWords2(template?.addedBy?.firstName) || ""}
                            </p>
                          </div>
                          <div className="flex items-center gap-3 text-gray-400">
                            <span className="flex items-center text-xs">
                              <CopyToClipboard
                                title={
                                  template?.addedBy?.email?.primary ||
                                  template?.addedBy?.email ||
                                  ""
                                }
                              />
                              <span className="text-[10px] lg:text-xs">
                                {template?.addedBy?.email?.primary ||
                                  template?.addedBy?.email ||
                                  ""}
                              </span>
                            </span>
                            <Divider orientation="vertical" />
                            <span className="text-[10px] lg:text-xs">
                              Used: {template?.usedCount || 0}
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                    headeRight={
                      <div className="md:grid md:grid-cols-2 xl:flex lg:gap-1 items-center xl:flex-wrap">
                        <Button
                          icon={"visibility"}
                          type="icon"
                          size="sm"
                          variant="text"
                          color="black"
                          onClick={() => {
                            setViewEmailModal(true);
                            setTemplateId(template?.uiid);
                          }}
                        />
                        <Button
                          icon={"edit_square"}
                          type="icon"
                          size="sm"
                          variant="text"
                          color="black"
                          onClick={() => handleEditTemplate(template?.uiid)}
                        />
                        {headeRightIcons.map((icon) => (
                          <Button
                            key={icon}
                            icon={icon}
                            type="icon"
                            size="sm"
                            variant="text"
                            color="black"
                            onClick={() =>
                              handleDuplicateTemplate(template?.uiid)
                            }
                          />
                        ))}
                        {(template?.addedBy?.uiid === user?.data?.uiid ||
                          user?.data?.role?.uiid === 1) && (
                          <Button
                            icon={"delete"}
                            type="icon"
                            size="sm"
                            variant="text"
                            color="black"
                            onClick={handleDeteteTemplate(template?.uiid)}
                          />
                        )}
                      </div>
                    }
                  >
                    <div className="flex lg:justify-around md:justify-between lg:gap-3 p-3">
                      <InfoTextAdv
                        title={"Created On"}
                        size="sm"
                        titleProps={{ className: "!text-black" }}
                        value={
                          <h6 className="text-black text-lg">
                            {/* {new Date(template.addedOn).toLocaleString(
                              "en-US",
                              {
                                month: "long",
                                day: "numeric",
                                year: "numeric",
                              }
                            )} */}
                            {new Date(
                              convertFromUTC(template?.addedOn),
                            ).toLocaleString("en-US", {
                              month: "long",
                              day: "numeric",
                              year: "numeric",
                            })}
                          </h6>
                        }
                      />
                      <div className="hidden lg:block">
                        <Divider orientation="vertical" />
                      </div>
                      <InfoTextAdv
                        title={"Last Used"}
                        titleProps={{ className: "!text-black" }}
                        size="sm"
                        value={
                          <h6 className="line-clamp-1 text-black">
                            {/* {new Date(template.lastUsed).toLocaleString(
                              "en-US",
                              {
                                month: "long",
                                day: "numeric",
                                year: "numeric",
                              }
                            )} */}
                            {template?.lastUsed
                              ? new Date(
                                  convertFromUTC(template?.lastUsed),
                                ).toLocaleString("en-US", {
                                  month: "long",
                                  day: "numeric",
                                  year: "numeric",
                                })
                              : "-"}
                          </h6>
                        }
                      />
                      <div className="hidden lg:block">
                        <Divider orientation="vertical" />
                      </div>
                      <InfoTextAdv
                        title={"Modified On"}
                        size="sm"
                        titleProps={{ className: "!text-black" }}
                        value={
                          <h6 className="line-clamp-1 text-black">
                            {/* {new Date(template.modified).toLocaleString(
                              "en-US",
                              {
                                month: "long",
                                day: "numeric",
                                year: "numeric",
                              }
                            )} */}
                            {template?.modified
                              ? new Date(
                                  convertFromUTC(template?.modified),
                                ).toLocaleString("en-US", {
                                  month: "long",
                                  day: "numeric",
                                  year: "numeric",
                                })
                              : "-"}
                          </h6>
                        }
                      />
                    </div>
                  </DetailCard>
                </div>
              ))}

              {/* Loading indicator for infinite scroll */}
              {isLoadingMore && (
                <div className="flex justify-center py-4">
                  <LogoLoader />
                </div>
              )}

              {/* End of list indicator */}
              {!hasMore && templates.length > 0 && (
                <div className="text-center py-4 text-gray-500">
                  No more templates to load
                </div>
              )}
            </>
          ) : (
            <p className="text-center text-gray-500">No templates available</p>
          )}
        </div>
      </div>

      <Modal
        isOpen={saveEmailModal}
        width="max-w-4xl"
        onClose={handleCloseSaveEmail}
        title="Save Email Template"
      >
        <SaveEmailTemplate
          onCancel={handleCloseSaveEmail}
          emailBody={emailBody}
          setEmailBody={setEmailBody}
          editTemplate={editTemplate}
        />
      </Modal>

      <Modal
        isOpen={viewEmailModal}
        width="max-w-4xl"
        onClose={handleCloseViewEmail}
        title="View Email Template"
      >
        <ViewEmailTemplate
          onCancel={handleCloseViewEmail}
          templateId={templateId}
          setEmailBody={setEmailBody}
        />
      </Modal>
      {loading1 && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/40 backdrop-blur-sm z-50 rounded-lg">
          <LogoLoader />
        </div>
      )}
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default EmailTemplates;
